"use strict";

jQuery(document).ready(function ($) {
  // Header Sticky
  $(this).scrollTop(0);
  $(window).scroll(function () {
    if ($(this).scrollTop() > 80) {
      $("header.site-header").addClass("is-sticky");
    } else {
      $("header.site-header").removeClass("is-sticky");
    }
  });

  if ($("header.site-header").offset().top > 80) {
    $("header.site-header").addClass("is-sticky");
  }

  // Services Menu Active State Management
  function initializeServicesMenu() {
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      initializeMobileBehavior();
    } else {
      initializeDesktopBehavior();
    }
  }

  // Desktop hover behavior
  function initializeDesktopBehavior() {
    $("body").removeClass("mobile-menu-active");
    $("[class*='services-category-']").removeClass("active");
    $("[class*='services-category-']").first().addClass("active");

    function waitForGSAP() {
      if (typeof gsap !== 'undefined' && typeof DrawSVGPlugin !== 'undefined') {
        gsap.registerPlugin(DrawSVGPlugin);
        gsap.set(".has-children-path path", { drawSVG: "0%" });

        $("[class*='services-category-']").off("mouseenter mouseleave click").on("mouseenter", function () {
          $("[class*='services-category-']").removeClass("active");
          $(this).addClass("active");

          gsap.set(".has-children-path path", { drawSVG: "0%" });
          const pathElement = $(this).find(".has-children-path path")[0];
          if (pathElement) {
            gsap.to(pathElement, {
              drawSVG: "100%",
              duration: 0.8,
              ease: "power2.out"
            });
          }
        });

        const firstPathElement = $("[class*='services-category-']").first().find(".has-children-path path")[0];
        if (firstPathElement) {
          gsap.to(firstPathElement, {
            drawSVG: "100%",
            duration: 0.8,
            ease: "power2.out",
            delay: 0.2
          });
        }
      } else {
        $("[class*='services-category-']").off("mouseenter mouseleave click").on("mouseenter", function () {
          $("[class*='services-category-']").removeClass("active");
          $(this).addClass("active");
        });
      }
    }

    if (typeof gsap !== 'undefined') {
      waitForGSAP();
    } else {
      setTimeout(waitForGSAP, 500);
    }
  }

  // Mobile click behavior
  function initializeMobileBehavior() {
    $("[class*='services-category-']").off("mouseenter mouseleave hover");
    $("body").addClass("mobile-menu-active");

    // Remove all active states and collapse all submenus
    $("[class*='services-category-']").removeClass("active");
    $("[class*='services-category-'] > a + .sub-menu").css('height', '0px').removeClass('expanded');

    // Click handler for toggle
    $(".service-path-icon").off("click").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const parentCategory = $(this).closest("[class*='services-category-']");
      const nestedSubmenu = parentCategory.find("> a + .sub-menu");
      const isActive = parentCategory.hasClass("active");

      if (isActive) {
        // Collapse current submenu
        parentCategory.removeClass("active");
        if (nestedSubmenu.length) {
          nestedSubmenu.css('height', '0px').removeClass('expanded');
        }
      } else {
        // Collapse others
        $("[class*='services-category-']").removeClass("active");
        $("[class*='services-category-'] > a + .sub-menu").css('height', '0px').removeClass('expanded');

        // Expand clicked submenu
        parentCategory.addClass("active");
        if (nestedSubmenu.length) {
          // Get actual height for smooth transition
          nestedSubmenu.css({
            'height': 'auto',
            'position': 'absolute',
            'visibility': 'hidden'
          });
          const autoHeight = nestedSubmenu.outerHeight();
          nestedSubmenu.css({
            'height': '0px',
            'position': '',
            'visibility': ''
          });

          setTimeout(() => {
            nestedSubmenu.css('height', autoHeight + 'px').addClass('expanded');
          }, 10);
        }
      }
    });
  }

  // Initialize on page load
  initializeServicesMenu();

  // Re-initialize when mobile menu toggled
  $(document).on('click', '.menu-toggle', function () {
    setTimeout(function () {
      initializeServicesMenu();
    }, 100);
  });

  // Re-initialize on resize
  let resizeTimeout;
  $(window).on('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      initializeServicesMenu();
    }, 250);
  });
});
